import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import "css/generalSettings.css";
import { warningErrorAction } from "actions/ErrorActions";
import ReportTemplateNT from './ReportTemplateNT'; 
import { helpHttp } from "service/HelpHttp";
import PropTypes from 'prop-types'; 

const initialStateFormNT = {
  id : "",
  ownformnt_id : "", 
  defaultStore_id:0, 
  useraccount_id:0,

  defaultformatnumber:1,
  isFinished:true,
  isScanned:false,
  preiddoc_sheet : "",
  sufiddoc_sheet : 0,

  number_nt: "",
  init_date_nt: "",
  end_date_nt: "",
  isindividual:false,
  ismultiple:true,
  frecuency: "",
  number_nt_refused: "",
  isemergency:false,
  reason_emergency: "",
   
  formopttrasstore_id: 0,
  opt_tras_store_id : 0,
  opt_tras_documnettype_id : 1,
  opt_tras_documentid : "",
  opt_tras_tradename : "",
  opt_tras_name : "",
  opt_tras_contactname : "",
  opt_tras_roadtype :  "",
  opt_tras_street : "",
  opt_tras_country_id:  1,
  opt_tras_country_name: "",
  opt_tras_province_id: 30,
  opt_tras_province_name: "",
  opt_tras_postalcode_id: 6911,
  opt_tras_postalcode_code: "",
  opt_tras_postalcode_name: "",
  opt_tras_community_id:  6, 
  opt_tras_community_name: "",
  opt_tras_phone: "",
  opt_tras_email: "",
  opt_tras_nima: "",
  opt_tras_cnae: "",
  opt_tras_inscription: "",
  opt_tras_opt:"",
  opt_tras_licenseplate: "",
  opt_tras_economicactivity: "",
  
  formoritrasstore_id: 0,
  ori_tras_store_id : 0,
  ori_tras_documnettype_id :1,
  ori_tras_documentid : "",
  ori_tras_tradename : "",
  ori_tras_name : "",
  ori_tras_contactname : "",
  ori_tras_roadtype :  "",
  ori_tras_street : "",
  ori_tras_country_id: 1,
  ori_tras_country_name: "",
  ori_tras_province_id: 30,
  ori_tras_province_name: "",
  ori_tras_postalcode_id: 6911,
  ori_tras_postalcode_code: "",
  ori_tras_postalcode_name: "",
  ori_tras_community_id: 6,
  ori_tras_community_name: "",
  ori_tras_phone: "",
  ori_tras_email: "",
  ori_tras_nima: "",
  ori_tras_cnae: "",
  ori_tras_inscription: "",
  ori_tras_opt:"",
  ori_tras_licenseplate: "",
  ori_tras_economicactivity: "",
  
  aut_tras_store_id : 0,
  aut_tras_documnettype_id : 1,
  aut_tras_documentid : "",
  aut_tras_tradename : "",
  aut_tras_name : "",
  aut_tras_contactname : "",
  aut_tras_roadtype : "",
  aut_tras_street : "",
  aut_tras_country_id: 1,
  aut_tras_country_name: "",
  aut_tras_province_id: 30,
  aut_tras_province_name: "",
  aut_tras_postalcode_id: 6911,
  aut_tras_postalcode_code: "",
  aut_tras_postalcode_name: "",
  aut_tras_community_id: 6,
  aut_tras_community_name: "",
  aut_tras_phone: "",
  aut_tras_email: "",
  aut_tras_nima: "",
  aut_tras_cnae: "",
  aut_tras_inscription: "",
  aut_tras_opt:"",
  aut_tras_licenseplate: "",
  aut_tras_economicactivity: "",
  
  formdesttrasstore_id: 0,
  dest_tras_store_id : 0,
  dest_tras_documnettype_id :1,
  dest_tras_documentid : "",
  dest_tras_tradename : "",
  dest_tras_name : "",
  dest_tras_contactname : "",
  dest_tras_roadtype : "",
  dest_tras_street : "",
  dest_tras_country_id: 1,
  dest_tras_country_name: "",
  dest_tras_province_id: 30,
  dest_tras_province_name: "",
  dest_tras_postalcode_id:6911,
  dest_tras_postalcode_code: "",
  dest_tras_postalcode_name: "",
  dest_tras_community_id: 6,
  dest_tras_community_name: "",
  dest_tras_phone: "",
  dest_tras_email: "",
  dest_tras_nima: "",
  dest_tras_cnae: "",
  dest_tras_inscription: "",
  dest_tras_opt:"",
  dest_tras_licenseplate: "",
  dest_tras_economicactivity: "",
 
  aut_dest_store_id : 0,
  aut_dest_documnettype_id :1,
  aut_dest_documentid : "",
  aut_dest_tradename : "",
  aut_dest_name : "",
  aut_dest_contactname : "",
  aut_dest_roadtype : "",
  aut_dest_street : "",
  aut_dest_country_id: 1,
  aut_dest_country_name: "",
  aut_dest_province_id: 30,
  aut_dest_province_name: "",
  aut_dest_postalcode_id: 6911,
  aut_dest_postalcode_code: "",
  aut_dest_postalcode_name: "",
  aut_dest_community_id: 6,
  aut_dest_community_name: "",
  aut_dest_phone: "",
  aut_dest_email: "",
  aut_dest_nima: "",
  aut_dest_cnae: "",
  aut_dest_inscription: "",
  aut_dest_opt:"",
  aut_dest_licenseplate: "",
  aut_dest_economicactivity: "",

  codeler_id : 0,
  codeler_code : "",
  codeler_namees : "",
  codeler_nameen : "",
  description_id : 0,
  description_code : "",
  description_namees : "",
  description_nameen : "",
  
  treatmenttypeorigin_id : 0,
  treatmenttypeorigin_code : "",
  treatmenttypeorigin_namees : "",
  treatmenttypeorigin_nameen : "",
 
  treatmenttypedestine_id : 0,
  treatmenttypedestine_code : "",
  treatmenttypedestine_namees : "",
  treatmenttypedestine_nameen : "",
  
  processtypepeorigin_id : 0,
  processtypepeorigin_code : "",
  processtypepeorigin_namees : "",
  processtypepeorigin_nameen : "",

  processtypedestine_id : 0,
  processtypedestine_code : "",
  processtypedestine_namees : "",
  processtypedestine_nameen : "",
  
  dangerousness_id : 0,
  dangerousness_namees : "",
  dangerousness_nameen : "",

  charac_danger : "",
  amount : 0,

  formreltransstore_id: 0,
  rel_trans_store_id : 0,
  rel_trans_documnettype_id : 0,
  rel_trans_documentid : "",
  rel_trans_tradename : "",
  rel_trans_name : "",
  rel_trans_contactname : "",
  rel_trans_roadtype :  "",
  rel_trans_street : "",
  rel_trans_country_id: 0,
  rel_trans_country_name : "",
  rel_trans_province_id: 0,
  rel_trans_province_name : "",
  rel_trans_postalcode_id:0,
  rel_trans_postalcode_code : "",
  rel_trans_postalcode_name : "",
  rel_trans_community_id: 0,
  rel_trans_community_name : "",
  rel_trans_phone: "",
  rel_trans_email: "",
  rel_trans_nima: "",
  rel_trans_cnae: "",
  rel_trans_inscription: "",
  rel_trans_opt:"",
  rel_trans_licenseplate: "",
  rel_trans_economicactivity: "",
  
  formrespprodstore_id: 0,
  resp_prod_store_id : 0,
  resp_prod_documnettype_id : 1,
  resp_prod_documentid : "",
  resp_prod_tradename : "",
  resp_prod_name : "",
  resp_prod_contactname : "",
  resp_prod_roadtype : "",
  resp_prod_street : "",
  resp_prod_country_id: 1,
  resp_prod_country_name: "",
  resp_prod_province_id: 30,
  resp_prod_province_name: "",
  resp_prod_postalcode_id:6911,
  resp_prod_postalcode_code: "",
  resp_prod_postalcode_name: "",
  resp_prod_community_id: 6,
  resp_prod_community_name: "",
  resp_prod_phone: "",
  resp_prod_email: "",
  resp_prod_nima: "",
  resp_prod_cnae: "",
  resp_prod_inscription: "",
  resp_prod_opt:"",
  resp_prod_licenseplate: "",
  resp_prod_economicactivity: "" 
 
};
 
const NTPDF = ({ rowEditNT, viewPDF, setViewPDF }) => {
  const { t, i18n } = useTranslation(['listDataForms']);
  const token = useSelector((state) => state.loginUser.token);
  const [dataNT, setDataNT] = useState(initialStateFormNT);  
  const [pdfOpened, setPdfOpened] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    let isMounted = true;  
    const fetchFileForm = async (fileName) => {
      if (pdfOpened) return; // Evita abrir el PDF dos veces
      try {
        const getData = await helpHttp().getfilesupload(ENDPOINT, `pdftos3uploader/downloadfroms3`, token,fileName);
        if (!getData) { 
          dispatch(warningErrorAction(t('Text_ConnectionFailed'))); 
        } else{
          if (getData && getData.size>0 && isMounted){
             // Open PDF in a new tab  
              const pdfData = new Blob([getData], { type: "application/pdf" });
           
              // Espera un pequeño tiempo antes de abrir la ventana, para evitar ejecuciones dobles
              setTimeout(() => {
                window.open(URL.createObjectURL(pdfData), "_blank");
              }, 100);
              setViewPDF(false); 
              setPdfOpened(false)
          } 
        }
      } catch (error) { 
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    const fetchDataForm = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT, `nt/getntpdfbyid/`, token, rowEditNT.id);
        if (getData.err) {
          setDataNT(initialStateFormNT);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailed' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataNT(getData);  
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
    if (
      rowEditNT?.id && 
      rowEditNT.id !== "0" &&
      rowEditNT.id !== "0" &&
      viewPDF
    ) {
      if (rowEditNT.isScanned){
        let fileName = rowEditNT.number_nt || "";
        fetchFileForm("NT_" + fileName + ".pdf");
      } else{
        fetchDataForm();
      }  
    }
 
    return () => {isMounted = false;};
  }, [rowEditNT, dispatch, t, token,i18n.language,setViewPDF,pdfOpened,viewPDF]);  
  return (
    !rowEditNT.isScanned && 
      <div id="pdf-content" style={{ padding: 10 }}>
        {(viewPDF && dataNT.id!==undefined  && dataNT.id!==null  && dataNT.id!=="" && dataNT.id!=="0" && dataNT.id!==0) &&
          <ReportTemplateNT dataNT={dataNT}  initialStateFormNT={initialStateFormNT} setDataNT={setDataNT} setViewPDF={setViewPDF}/>
        }   
      </div>
       
  );
};

NTPDF.propTypes = {
  rowEditNT: PropTypes.object.isRequired,
  viewPDF: PropTypes.bool.isRequired,
  setViewPDF: PropTypes.func.isRequired
};

export default NTPDF;
